export class DeleteImageProfile {
    constructor(ImageProfileRepository) {
      this.ImageProfileRepository = ImageProfileRepository;
    }
  
    async execute(ImageProfileId) {
      return await this.ImageProfileRepository.DeleteImageProfile(ImageProfileId);
    }
  }